<div class="stewards-modal">
  <div class="modal-header stewards-modal-header">
    <h4 class="modal-title text-truncate">Possible Fixture Suspension Dates</h4>
    <button type="button" class="stewards-modal-close" (click)="close()" aria-label="Close">
      <fa name="times"></fa>
    </button>
  </div>
  <div class="modal-body stewards-modal-body">
    <div class="row">
      <div class="col">
        <p class="stewards-modal-label">Possible suspension dates</p>
        <p class="stewards-modal-text">{{ suspensionDates }}</p>
      </div>
    </div>
    <div class="row">
      <div class="col">
        <p class="stewards-modal-label">Possible suspension dates with G1 races</p>
        <ul class="stewards-modal-list">
          <li *ngFor="let suspensionDate of suspensionG1RacesDates">
            {{suspensionDate}}
          </li>
        </ul>
      </div>
    </div>
  </div>
  <div class="modal-footer stewards-modal-footer">
    <button type="button" class="btn btn-outline-secondary stewards-modal-btn-close" (click)="close()">Close</button>
  </div>
</div>
